export default function PHP_timezone_location_get() {
  return (
    <div>
      <h1>PHP_timezone_location_get</h1>
    </div>
  );
}
